import { CIProviderStepTwoFileProps } from "../components";
import { DEFAULT_GHA_OPTIONS } from "../constants";
import { CIProvider } from "../types";

import {
  getAzureCIYAML,
  getBitbucketCIYAML,
  getBuildkiteCIYAML,
  getCircleCIYAML,
  getGitHubYAML,
  getGitLabYAML,
  getJenkinsCIYAML,
} from "./configFileGenerators";

/**
 * Can't just use a constant here because the orgId is necessary
 * to generate some of the configs
 */
export const getSetupCIFileProps = (
  provider: CIProvider,
  orgId: string
): CIProviderStepTwoFileProps => {
  const SETUP_CI_FILE_PROPS_BY_PROVIDER: {
    [key in CIProvider]: CIProviderStepTwoFileProps;
  } = {
    github: {
      ciProvider: "github",
      configFileName: "semgrep.yml",
      whereToAdd: "GitHub Actions",
      customConfigHref:
        "https://semgrep.dev/docs/semgrep-ci/sample-ci-configs/#github-actions",
      configYaml: getGitHubYAML({
        ...DEFAULT_GHA_OPTIONS,
        publishUrl: window.origin,
      }),
    },
    gitlab: {
      ciProvider: "gitlab",
      configFileName: ".gitlab-ci.yml",
      whereToAdd: "CI/CD",
      customConfigHref:
        "https://semgrep.dev/docs/semgrep-ci/sample-ci-configs/#gitlab-ci",
      configYaml: getGitLabYAML(true, false, false, orgId),
    },
    jenkins: {
      ciProvider: "jenkins",
      whereToAdd: "the Pipeline",
      configFileName: "Jenkinsfile",
      customConfigHref:
        "https://semgrep.dev/docs/semgrep-ci/sample-ci-configs/#jenkins",
      configYaml: getJenkinsCIYAML(),
    },
    bitbucket: {
      ciProvider: "bitbucket",
      whereToAdd: "the Pipeline",
      configFileName: "bitbucket-pipelines.yml",
      customConfigHref:
        "https://semgrep.dev/docs/semgrep-ci/sample-ci-configs/#bitbucket",
      configYaml: getBitbucketCIYAML(),
    },
    circleci: {
      ciProvider: "circleci",
      whereToAdd: "the Pipeline",
      configFileName: ".circleci/config.yml",
      customConfigHref:
        "https://semgrep.dev/docs/semgrep-ci/sample-ci-configs/#circleci",
      configYaml: getCircleCIYAML(),
    },
    buildkite: {
      ciProvider: "buildkite",
      whereToAdd: "the Pipeline",
      configFileName: "pipeline.yml",
      customConfigHref:
        "https://semgrep.dev/docs/semgrep-ci/sample-ci-configs/#buildkite",
      configYaml: getBuildkiteCIYAML(),
    },
    azure: {
      ciProvider: "azure",
      whereToAdd: "the Pipeline",
      configFileName: "azure-pipelines.yml",
      customConfigHref:
        "https://semgrep.dev/docs/semgrep-ci/sample-ci-configs/#azure",
      configYaml: getAzureCIYAML(),
    },
  };

  return SETUP_CI_FILE_PROPS_BY_PROVIDER[provider];
};
